import React from 'react';

function CustomerAddress({
                           sendData, setSendData, initialData, componentData, setComponentData,
                         }) {

  return (<div className={"solid-dyna-input"} style={{height:'70px'}}>
    <label htmlFor="">آدرس</label>
    <textarea
      placeholder={"آدرس مشتری"}
      value={sendData?.customerAddress ? sendData?.customerAddress : ""}
      onChange={e=> setSendData({customerAddress:e.target.value})}
    />
  </div>);
}

export default CustomerAddress;